module.exports = __webpack_public_path__ + "static/media/icon-catalog-feed-done.b6e37b5f.svg";